<template>
  <div class="paragraph-s text-neutral-secondary">
    {{ hint }}
    <a v-if="isLMS" v-b-toggle.source-material-sidebar href="#">{{
      $t("common.clickHere")
    }}</a>
  </div>
</template>

<script>
import { LMS_PROVIDERS } from "@/constants";
import isLMSMixin from "@/mixins/isLMS";
export default {
  name: "SourceMaterialHint",

  mixins: [
    // this.isLMS
    // this.platform
    isLMSMixin,
  ],

  computed: {
    hint() {
      if (this.isLMS) {
        return this.$t("essays.lmsInstructionsUsed", {
          platform: LMS_PROVIDERS[this.platform].label,
        });
      }

      return this.$t("essays.addWritingPromptHint");
    },
  },
};
</script>
